<!-- <div class="m-t10 flex-row-end"><gp-pvfv-setting></gp-pvfv-setting></div> -->
<!-- <button (click)="onResize()">Resize</button> -->
<div  *ngIf="!isDataAvailable" class="flex-col-center m-t75">       
    <gp-chart-loading-animation></gp-chart-loading-animation>
</div>
<highcharts-chart  *ngIf="isDataAvailable"
    [Highcharts] = "Highcharts"
    [callbackFunction]="chartCallBack" 
    [options]="options"  
    style="width: 100%; height: 95%; display: block;">
</highcharts-chart>            

<!-- <highcharts-chart  
    [Highcharts] = "Highcharts"
    [options]="options"  
    [callbackFunction]="chartCallBack" 
    style="width: 100%; height: 95%; display: block;">
</highcharts-chart>             -->

